import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { exists, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { _className, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import './Renderer_Transition.scss';
import { ModuleFE_PathwayState, ModuleFE_PathwayTransition } from '../../../_entity.js';
export const Renderer_Transition = (props) => {
    const transition = typeof props.transition === 'string'
        ? ModuleFE_PathwayTransition.cache.unique(props.transition)
        : props.transition;
    if (!transition)
        throw new MUSTNeverHappenException(`Could not resolve transition from props ${props.transition}`);
    const origin = ModuleFE_PathwayState.cache.unique(transition.sourceId);
    const target = ModuleFE_PathwayState.cache.unique(transition.targetId);
    if (!origin)
        throw new MUSTNeverHappenException(`Could not get origin state for id ${transition.sourceId}`);
    if (!target)
        throw new MUSTNeverHappenException(`Could not get origin state for id ${transition.targetId}`);
    const className = _className('pathway__transition', props.className, props.onClick && 'clickable');
    return _jsxs(LL_H_C, { className: className, onClick: props.onClick, children: [_jsx("div", { className: 'pathway__transition__source', children: origin.name }), _jsx(ICONS.circleArrow.component, {}), _jsx("div", { className: 'pathway__transition__target', children: exists(transition.label) ? transition.label : target.name })] });
};
//# sourceMappingURL=Renderer_Transition.js.map